import { render, staticRenderFns } from "./open_messages.vue?vue&type=template&id=cd3a2d40"
import script from "./open_messages.vue?vue&type=script&lang=js"
export * from "./open_messages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports